<template>
  <div class="header" :class="{'sticky': isTop}">
    <div class="header-menus">
      <div>
         <router-link to="/">
          <a　class="header-menus_a">
            <img class="mira-logo_image" src="@/assets/mira-logo.png" />
          </a>
        </router-link>
      </div>
      <div>
        <ul class="header-menus_ul">
          <li class="header-menus_li">
            <router-link to="/"><a class="header-menus_a">トップ</a></router-link>
          </li>
          <li class="header-menus_li">
            <a class="header-menus_a" href="https://mira-now.site/" target="_blank">ミラマガジン</a>
          </li>
        </ul>
      </div>
      <div class="header-actions">
       <router-link to="/scout"><a class="header-menus_btn header-action" target="_blank">スカウト</a></router-link>
       <a class="header-menus_btn header-action" href="https://forms.gle/n9w3YjUg8tR6ABUT9" target="_blank">広告掲載</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      scrollY: 0,
      prevScrollY: 0,
      scrollDirection: 0,
    }
  },
  computed: {
    isTop() {
      return this.scrollY === 0;
    },
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.prevScrollY = this.scrollY;
      this.scrollY = window.pageYOffset;
      this.scrollDirection = this.scrollY - this.prevScrollY;
    });
  }
};
</script>

<style scoped>
.header {
  width: 100%;
  position: fixed;
  z-index: 10;
  padding: 16px 0px;
  background-color: rgba(228,172,161,0.85);
  transition: .5s
}
.header.sticky{
  background-color: transparent;
}
.header-menus {
  width: 100%;
  max-width: 960px;
  margin: 0px auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-menus_ul {
  flex: 1;
  margin: 0px;
  padding-left: 0px;
}
.header-menus_li {
  display: inline-block;
  list-style: none;
  padding: 0px 16px 0px;
}
.header-menus_a {
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
}
.header-actions {
  display: flex;
}
.header-action {
 margin-left: 8px;
}
.header-menus_btn {
  display: block;
  max-width: 160px;
  border-radius: 21px;
  padding: 8px 24px;
  font-size: 12px;
  font-weight: 400;
  color: #140a1e;
  background-color: #ffffff;
}
.header-menus_btn:hover {
  color: #140a1e;
}
.mira-logo_image {
  height: 32px;
}

@media screen and (max-width: 768px) {
}
@media screen and (max-width: 480px) {
  .header {
    padding: 16px 16px;
  }
  .header-menus_ul {
    display: none;
  }
  .mira-logo_image {
    height: 32px;
  }
}
@media screen and (max-width: 320px) {
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue